import { useParams } from "react-router-dom";
import Login from "../login/Login";

function LoginContainer() {
  const { appName, permissions, apps, urlOK, urlKO, logo, userId, signature, timestamp } = useParams();
  const allPermissions = permissions
    .split(",")
    .map((item) => item.toUpperCase());
  const allApps = apps.split(",").map((item) => item.toUpperCase());

  return (
    <div className="container">
      <Login
        appName={appName}
        permissions={allPermissions}
        apps={allApps}
        redirectOK={urlOK}
        redirectKO={urlKO}
        logoURI={logo}
        userId={userId}
        signature={signature}
        timestamp={timestamp}
      ></Login>
    </div>
  );
}
export default LoginContainer;
